import { useState, useEffect, useCallback } from 'react';
import {
  getUsers,
  createUser,
  updateUser,
  deleteUser as deleteUserApi
} from "../services/userService";

export default function useUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadIndex, setReloadIndex] = useState(0);

  const reload = useCallback(() => setReloadIndex(i => i + 1), []);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getUsers();
      setUsers(res);
    } catch (err) {
      console.error("Unexpected error in useUsers:", err);
      setUsers([]);
      setError("Error loading users");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) fetchUsers();
    return () => { isMounted = false; };
  }, [reloadIndex, fetchUsers]);

  const saveUser = async (mode, username, values) => {
    try {
      if (mode === "create") {
        await createUser(values);
        return { success: true, message: "User created" };
      } else if (mode === "edit") {
        await updateUser(username, values);
        return { success: true, message: "User updated" };
      } else {
        throw new Error("Invalid mode");
      }
    } catch (err) {
      console.error("Error saving user:", err);
      return { success: false, message: "Failed to save user" };
    }
  };

  const deleteUser = async (username) => {
    try {
      await deleteUserApi(username);
      return { success: true, message: "User deleted" };
    } catch (err) {
      console.error("Error deleting user:", err);
      return { success: false, message: "Failed to delete user" };
    }
  };

  return {
    users,
    loading,
    error,
    reload,
    saveUser,
    deleteUser
  };
}
